import React, {Component} from 'react';
import {MoneyField, MoneyWithCurrencyField} from "buenLib/components/MoneyField";
import {Spinner} from "reactstrap";
import 'assets/sass/dashboard/deposits/withdraws/WithdrawSummary.scss';
import {CopyToClipboardElement} from "components/dashboard/common/CopyToClipboardElement";
import { AppContext } from 'app/state/AppContext';
import { CoinDepositBlockchainWarning } from 'buenLib/components/CoinDepositBlockchainWarning';

export class WithdrawSummaryStep extends Component {
    static contextType = AppContext;

    renderConfirmWithdrawButton() {
        if (this.props.operationInProgress) {
            return <Spinner className="spinner-color"/>;
        }
        return (
            <button className="cta-button mt-3" onClick={this.props.handleContinue}>
                CONFIRMAR ENVÍO
            </button>
        )
    }

    render() {
        const form = this.props.withdrawForm;
        const { getCurrencyInstance } = this.context;

        return (<>
            <div className="summary">
                <h1>Resumen de la transferencia</h1>
                <div className="receipt-box">
                    <div className="box-header">
                        <div className="money">
                            <span
                                className="currency">{getCurrencyInstance(this.props.currency).code()}</span>
                            <span className="price">
                                <MoneyField value={form.amountField().value()} currency={form.currency()}/>
                            </span>
                        </div>
                    </div>
                    <div className="data coin">
                        {this.renderWalletAddress(form)}
                        {this.renderNetworkFee(form)}
                        {this.renderBuenbitFee(form)}
                        {this.renderDate()}
                    </div>

                    <div className="text-center">
                        {this.renderConfirmWithdrawButton()}
                    </div>
                   
                </div>
            </div>
             <div className="text-center">
                <CoinDepositBlockchainWarning currency={this.props.currency} />
                <div className="text-center mt-4 mb-4">
                    <p className="text-terms">
                        * Los envíos erróneos no son reversibles ni reembolsables
                    </p>
                </div>
            </div>
            </>
        );
    }

    renderWalletAddress(form) {
        return <div className="data-row">
            <span className="label">Dirección</span>
            <span className="value wallet-address">
                <CopyToClipboardElement content={<span className="copy-link">{form.walletAddress()}</span>}
                                        valueToCopy={form.walletAddress()}
                                        mouseOverTooltipMessage="Clickeá para copiar la dirección"
                                        copiedTooltipMessage="¡Dirección copiada al portapapeles!"/>
            </span>
        </div>;
    }

    renderNetworkFee(form) {
        const fee = form.fee() || 0;
        if (fee > 0) {
            let moneyField = <MoneyWithCurrencyField value={fee.toString()} currency={form.currency()}/>;
            return this.renderSummaryDataField(moneyField, "Comisión de la red");
        }
    }

    renderBuenbitFee(form) {
        const fee = form.fee() || 0;
        if (fee > 0) {
            let moneyField = <span className="buenbit-commission">Gratis</span>;
            return this.renderSummaryDataField(moneyField, "Comisión de Buenbit");
        }
    }

    renderDate() {
        return this.renderSummaryDataField(new Date().toLocaleDateString("es"), "Fecha");
    }

    renderSummaryDataField(data, label) {
        if (data) {
            return <div className="data-row">
                <span className="label">{label}</span>
                <span className="value">{data}</span>
            </div>;
        }
    }
}
